import React from "react";

import "./style.css";

function Hero({scrollToWork}) {

  const handleWorkClick = () => {
    scrollToWork()
  }

  return (
    // <Fade duration={500}>
       <div className="hero">
         <p className="hero__subHeading">your go-to web/app developer</p>

         <h3 className="hero__heading">
           Let's turn your <strong className="text__highlight">ideas</strong>{" "}
           into reality.
         </h3>

         <div className="hero__cta__button" onClick={handleWorkClick}>
           <span>My Work</span>
         </div>
       </div>
    //  </Fade>
  );
}

export default Hero;
